/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'expose?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'jquery.scrollto/jquery.scrollTo';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar';
import 'imagesloaded/imagesloaded';
import '@fancyapps/fancybox/dist/jquery.fancybox';


import '../css/theme';
import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';
import './jPushMenu';

import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';
import './lib/jquery.bxslider-rahisified.min';

import './components/block-cart';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  let dropDown = new DropDown(dropDownEl);
  let topMenu = new TopMenu(topMenuEl);
  let productMinitature = new ProductMinitature();
  let productSelect  = new ProductSelect();
  dropDown.init();
  form.init();
  topMenu.init();
  productMinitature.init();
  productSelect.init();

    $(".toggle-menu").jPushMenu({closeOnClickLink: false, closeOnClickOutside:false});

    function jqUpdateSizePage() {

        $('#bxsliderFeaturedProducts').bxSlider({
            slideMargin: 5,
            autoReload: true,
            breaks: [{screen:0, slides:1, pager:false},{screen:544, slides:2, pager:false},{screen:768, slides:2, pager:false},{screen:1100, slides:3, pager:false}],
            moveSlides: 1
        });

        var $windowWidth = $(window).width();

        if($windowWidth > 991) {
            var $bannerHome01 = $("#index #blockBanners01").height();
            $("#index #blockGammes").css("min-height", $bannerHome01-10);

            var $bannerHome02 = $("#index #blockBanners02").height();
            $("#index #blockVideo a").css("height", $bannerHome02-10);

        }

    }

    jqUpdateSizePage();


    $(window).resize(jqUpdateSizePage);

    var menuInitialPosition = 0;
    var ref = $('#menuHeader').position();
    var refTop = $(window).scrollTop();
    $(window).scroll(function () {
        //Fixed Menu Events
        var ref = $('#menuHeader').offset();
        var refTop = ref.top;
        var pos = $(window).scrollTop();
        var documentWidth = $(window).width();
        if (documentWidth > 991) {
            if (pos <= menuInitialPosition) {
                $('#menuHeader').removeClass('fixed-top').removeAttr('style');
                menuInitialPosition = 0;
            } else if (pos > refTop + 200) {
                $('#menuHeader').addClass('fixed-top').animate({
                    top: 0
                }, 1500);
                menuInitialPosition = refTop;
            }
        }
    });

    $(".btSearchMobile").click(function(e){
        e.stopPropagation();
        e.preventDefault();

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(".searchBlock").removeClass("opened");
        } else {
            $(this).addClass("active");
            $(".searchBlock").addClass("opened");
        }
    });

    $(document).imagesLoaded(function(){
        jqUpdateSizePage();
    });

    $('.language-selector .dropdown-menu').append('<li>\n'+
        '<a href="http://www.cliniqueducheveu.be/fr/boutique/" class="dropdown-item">be</a>\n'+
        '</li>');
    $('.language-selector .dropdown-menu').append('<li>\n'+
        '<a href="http://www.cliniqueducheveu.nl/shop/" class="dropdown-item">nl</a>\n'+
        '</li>');


    // $(".btPopup").click(function(e){
    //     e.stopPropagation();
    //     e.preventDefault();
    //     $('#popupLoading').slideToggle( "slow" );
    //     $("#popupLoading").removeClass("active");
    // });
    //
    // var isshow = localStorage.getItem('popup');
    // if ((isshow==null || isshow < new Date().getTime() )) {
    //     $('#popupLoading').slideToggle( "slow" );
    //     $("#popupLoading").addClass("active");
    //     localStorage.setItem('popup', new Date().getTime()+ 24 * 60 * 60 * 1000);
    // }
    //
    // setTimeout(function(){
    //     if ($('#popupLoading').hasClass("active")) {
    //         $('#popupLoading').slideToggle("slow");
    //         $("#popupLoading").removeClass("active");
    //     }
    // },15000);

    $('#checkboxData').click(function(){
        console.log('')
        $('#submitButton').prop('disabled', !$('#checkboxData').is(":checked"));
    });


});



// WEBPACK FOOTER //
// ./js/theme.js